import Vue from 'vue';
import Component from 'vue-class-component';

// Stores.

// Composants.
import DialogComponent from '@/shared/components/dialog/Dialog.vue'
import utilisateurProducteurService from '@/services/utilisateurProducteur/UtilisateurProducteurService';


import { SecurityStoreMethods } from '@/store/security/SecurityStore';
import { Getter } from 'vuex-class';
import { Template } from '@/models/Template.model';
import { MessageLevel } from '@/shared/enums/MessageLevel.enum';
import store from '@/store';



/** 
 * Composant TemplatePos
 */
@Component({
    components: {
        'go-dialog-pos': DialogComponent
    }
})
export default class TemplatePosPopUp extends Vue {


    public title: string = 'Information';
    public mainButtonActionText: string = 'J\'ai compris';

    /**
    *  Définie si l'utilisateur courant a signé le template POS.
    */
    @Getter(SecurityStoreMethods.GET_USER_SHOULD_SIGN_TEMPLATE_POS)
    public shouldSignTemplatePos: boolean;


    // Utilisez une propriété calculée pour lier dynamiquement la valeur du store à popInSignaturePos
    public get computedPopInSignaturePos(): { active: boolean } {
        return { active: this.shouldSignTemplatePos };
    }

    /**
     * Le template
     */
    public template: Template;

    /**
     * Si la page est chargée
     */
    public isLoad = false;

    /**
     * Le service générique pour les appels api
     */
    private utilisateurProducteurService = new utilisateurProducteurService();



    /**
     * Action de signer le dernier template POS
     * par l'utilisateur actuellement authentifié.
     */
    public signerTemplatePos() {
        this.utilisateurProducteurService.signerTemplatePos().then(
            (response) => {
                const temPlatePosSigned = !response.data.messages.some(m => m.messageLevel=== MessageLevel.Error);
                if (temPlatePosSigned) {
                    store.commit(SecurityStoreMethods.SET_USER_HAS_SIGNED_TEMPLATE_POS);
                }
            }
        );
    }
}
